import BuyTogetherQuery from 'Query/BuyTogether.query';
import { updateBuyTogether } from 'Store/BuyTogether/BuyTogether.action';
import { showNotification } from 'Store/Notification/Notification.action';
import { QueryDispatcher } from 'Util/Request';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';

export class BuyTogetherDispatcher extends QueryDispatcher {
    constructor() {
        super('BuyTogether', ONE_MONTH_IN_SECONDS);
    }

    onSuccess({ getGroupProducts: { products } }, dispatch) {
        dispatch(updateBuyTogether(products));
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', 'Error fetching BuyTogether!', error));
    }

    prepareRequest(products) {
        return [
            BuyTogetherQuery.getProducts(products)
        ];
    }

    clearBuyTogether(dispatch) {
        dispatch(updateBuyTogether([]));
    }
}

export default new BuyTogetherDispatcher();
